import { versionMajorMinor } from 'typescript';

// GENERATED: This file is generated by build-tools/code-gen.ts -- Do not edit by hand!

/** The short version number for this JSII compiler (e.g: `X.Y.Z`) */
export const SHORT_VERSION = '5.9.37';

/** The qualified version number for this JSII compiler (e.g: `X.Y.Z (build #######)`) */
export const VERSION = '5.9.37 (build 5176c0d)';

/** The release line identifier for this JSII compiler (e.g: `X.Y`) */
export const RELEASE_LINE = versionMajorMinor;
